import { render, staticRenderFns } from "./teamDialog.vue?vue&type=template&id=1752d032&scoped=true&"
import script from "./teamDialog.vue?vue&type=script&lang=js&"
export * from "./teamDialog.vue?vue&type=script&lang=js&"
import style0 from "./teamDialog.vue?vue&type=style&index=0&id=1752d032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1752d032",
  null
  
)

export default component.exports